import type { CSSProperties } from "react";
import {
  resolveEnvironmentTag,
  type EnvironmentTagModelOptions,
} from "./model";

export type EnvironmentTagProps = EnvironmentTagModelOptions & {
  style?: CSSProperties;
};

export function EnvironmentTag({ style, ...options }: EnvironmentTagProps) {
  const model = resolveEnvironmentTag({
    ...options,
    origin:
      options.origin ||
      (typeof window !== "undefined" ? window.location.origin : ""),
  });
  if (!model.visible) return null;
  return (
    <div
      aria-label="Environment tag"
      style={{ ...(model.style as CSSProperties), ...style }}
    >
      {model.text}
    </div>
  );
}

export default EnvironmentTag;
